import React from 'react'
import { Link } from '@inertiajs/react'
import styles from './BreadcrumbLink.module.scss'

interface BreadcrumbLinkProps {
  href: string
  children: React.ReactNode
  className?: never
}

export const BreadcrumbLink: React.FC<BreadcrumbLinkProps> = ({ href, children }) => (
  <Link href={href} className={styles.link}>{children}</Link>
)
